import { utils } from 'pixi.js';

export class KeyboardInput extends utils.EventEmitter {
    static keyState = {
        down: 'keydown',
        up: 'keyup',
    };

    constructor(actions) {
        super();

        /*         this.actions = [{
                    action: 'MOVE_UP', binds: [
                        { key: 'w' }, { key: 'W' }, { key: 'ArrowUp' },
                    ]
                }]; */

        this.bindDefaults = { lossless: false, autoRepeat: false };
        this.binds = [];

        this.keyBuffer = [];
        this.keyBufferTime = 50;

        this.actionRepeats = new Map();
        this.actionRepeatRate = 250;

        this.setupBinds(actions);
        this.setupEvents();
    }

    setupBinds(actions) {
        this.createBind({ key: 'w', action: actions.moveUp });
        this.createBind({ key: 's', action: actions.moveDown });
        this.createBind({ key: 'a', action: actions.moveLeft });
        this.createBind({ key: 'd', action: actions.moveRight });
        this.createBind({ key: 'e', action: actions.interact, lossless: true });

        this.createBind({ key: 'W', action: actions.moveUp });
        this.createBind({ key: 'S', action: actions.moveDown });
        this.createBind({ key: 'A', action: actions.moveLeft });
        this.createBind({ key: 'D', action: actions.moveRight });
        this.createBind({ key: 'E', action: actions.interact, lossless: true });

        this.createBind({ key: 'ArrowUp', action: actions.moveUp });
        this.createBind({ key: 'Up', action: actions.moveUp });
        this.createBind({ key: 'ArrowDown', action: actions.moveDown });
        this.createBind({ key: 'Down', action: actions.moveDown });
        this.createBind({ key: 'ArrowLeft', action: actions.moveLeft });
        this.createBind({ key: 'Left', action: actions.moveLeft });
        this.createBind({ key: 'ArrowRight', action: actions.moveRight });
        this.createBind({ key: 'Right', action: actions.moveRight });
        this.createBind({ key: 'Enter', action: actions.interact, lossless: true });
    }

    createBind(bind) {
        this.binds.push(Object.assign({}, this.bindDefaults, bind));
    }

    setupEvents() {
        let targetWindow = window;
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)){
            targetWindow = window.parent || window;
        }
        targetWindow.addEventListener('keydown', this.onKeyDown, false);
        targetWindow.addEventListener('keyup', this.onKeyUp, false);

    }

    onKeyDown = (event) => {
        this.keyBuffer.push(event);
    };

    onKeyUp = (event) => {
        this.keyBuffer.push(event);
    };

    update(dt) {
        let timestamp = Date.now();

        let keyBufferCopy = this.keyBuffer.slice();
        this.keyBuffer = [];

        for (let i = 0; i < keyBufferCopy.length; i++) {
            const event = keyBufferCopy[i];
            let isReady = this.processKeyEvent(timestamp, keyBufferCopy.slice(i + 1), event);
            // If the key has been in the buffer less than 50ms than keep it waiting.
            if (!isReady) this.keyBuffer.push(event);
        }
    }

    processKeyEvent(timestamp, keyBuffer, event) {
        if (timestamp - event.timeStamp < this.keyBufferTime) return false;
        console.log(event);
        const keyName = event.key;
        const keyState = event.type;

        if (keyName === 'Control' || keyName === 'Alt' || keyName === 'AltGraph' ||
            event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
            return true;
        }

        let bind = this.binds.find((bind) => {
            return bind.key === keyName;
        });

        if (!bind) return true;

        let opts = { isDown: false },
            shouldSend = true;

        if (keyState === KeyboardInput.keyState.down) opts.isDown = true;
        else if (keyState === KeyboardInput.keyState.up) opts.isDown = false;

        if (!bind.autoRepeat) shouldSend = this.setRepeatState(bind, opts);

        if (shouldSend) this.emit(bind.action, opts);

        return true;
    }

    /**
     * Turns a keyboard auto-repeat into a continuous digital signal.
     */
    setRepeatState(bind, opts) {
        if (this.actionRepeats.has(bind.action) && opts.isDown === this.actionRepeats.get(bind.action)) return false;

        this.actionRepeats.set(bind.action, opts.isDown);
        opts.autoRepeat = { repeat: opts.isDown, repeatRate: this.actionRepeatRate };
        return true;
    }
}
